import { Method } from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const HttpMethods: { [key: string]: Method } = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
